// Galerie produit : passer d'une image à l'autre en glissant (doigt ou souris), en boucle, en plus des vignettes.
// Mobile au doigt : défilement natif de Dawn, rien à faire. Sinon (souris, ou mise en page « vignettes » en
// desktop où une seule image est affichée) : un glissement horizontal appelle setActiveMedia de Dawn, qui
// synchronise vignettes, badge 1re image et lecteurs vidéo.
(() => {
  const THRESHOLD = 40;

  const mediaItems = (list) => Array.from(list.querySelectorAll(':scope > [data-media-id]'));

  const currentIndex = (list, items) => {
    if (list.scrollWidth > list.clientWidth + 1) {
      const left = list.getBoundingClientRect().left;
      const gap = (item) => Math.abs(item.getBoundingClientRect().left - left);
      let best = 0;
      items.forEach((item, index) => {
        if (gap(item) < gap(items[best])) best = index;
      });
      return best;
    }
    return Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
  };

  const init = (gallery) => {
    const list = gallery.querySelector('.product__media-list');
    if (!list || list.dataset.dxSwipe) return;
    list.dataset.dxSwipe = '';
    const scrollable = () => list.scrollWidth > list.clientWidth + 1;
    let start = null;
    let swiped = false;

    // En boucle : après la dernière image, la première, et inversement.
    const go = (dx, fromIndex) => {
      const items = mediaItems(list);
      if (items.length < 2) return;
      const index = (fromIndex + (dx < 0 ? 1 : -1) + items.length) % items.length;
      swiped = true;
      if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(items[index].dataset.mediaId, false);
    };

    const isSwipe = (dx, dy) => Math.abs(dx) >= THRESHOLD && Math.abs(dx) > Math.abs(dy);

    list.addEventListener('dragstart', (event) => event.preventDefault());

    // Souris (et stylet / doigt quand la galerie n'est pas un défilement natif, desktop « vignettes »).
    list.addEventListener('pointerdown', (event) => {
      if (event.button !== 0 || (event.pointerType === 'touch' && scrollable())) return;
      start = { x: event.clientX, y: event.clientY, index: currentIndex(list, mediaItems(list)) };
      swiped = false;
    });

    list.addEventListener('pointerup', (event) => {
      if (!start) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      const from = start.index;
      start = null;
      if (isSwipe(dx, dy)) go(dx, from);
    });

    list.addEventListener('pointercancel', () => (start = null));

    // Doigt sur le défilement natif (mobile) : Dawn fait défiler, on ne gère que le passage aux extrémités
    // (glisser vers la gauche sur la dernière image, vers la droite sur la première).
    let touch = null;
    list.addEventListener(
      'touchstart',
      (event) => {
        if (!scrollable() || event.touches.length !== 1) return (touch = null);
        const items = mediaItems(list);
        touch = { x: event.touches[0].clientX, y: event.touches[0].clientY, index: currentIndex(list, items), last: items.length - 1 };
      },
      { passive: true }
    );
    list.addEventListener(
      'touchend',
      (event) => {
        if (!touch) return;
        const point = event.changedTouches[0];
        const dx = point.clientX - touch.x;
        const dy = point.clientY - touch.y;
        const { index, last } = touch;
        touch = null;
        if (!isSwipe(dx, dy)) return;
        if ((index === last && dx < 0) || (index === 0 && dx > 0)) go(dx, index);
      },
      { passive: true }
    );

    // Un glissement ne doit pas ouvrir la visionneuse (clic sur l'image).
    list.addEventListener(
      'click',
      (event) => {
        if (!swiped) return;
        swiped = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  };

  const run = () => document.querySelectorAll('media-gallery').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
